import WAboutCompareFirst from './WAboutCompareFirst'

export default WAboutCompareFirst
